import { createContext } from 'react';

export const GoogleLoaderContext = createContext({ loaded: false, error: false });
export const GoogleLoaderProvider = GoogleLoaderContext.Provider;
